import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetUsersRequest = (role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Users/GetUsers`,
	params: { role }
});

export const GetUsersStatsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Users/GetUsersStats`,
	params: {}
});

export const GetRolesRequest = (role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Users/GetRoles`,
	params: { role }
});

export const GetOperatorsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Users/GetOperators`,
	params: {}
});

export const GetOperatorProjectsRequest = (operatorIds) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Users/GetOperatorProjects`,
	params: { operatorIds }
});

export const CreateUserRequest = (user) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Users/CreateUser`,
	data: user
});

export const EditUserRequest = (user) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Users/EditUser`,
	data: user
});

export const GetUserRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Users/GetUserById`,
	params: { userId }
});

export const ResendConfirmationEmailRequest = (userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Users/ResendConfirmationEmail`,
	params: { userId }
});

export const DeactivateUserRequest = (userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Users/DeactivateUser`,
	params: { userId }
});
